<template>
    <span class="navbar-text">
        <slot />
    </span>
</template>

<script>
export default {

    name: 'NavbarText'

};
</script>
